<template>
  <Section v-loading="loading" id="multiple-barcode-view">
    <div v-if="showBarcodes">
      <div class="inner-navbar">
        <el-form
          :inline="true"
          class="barcode-form-inline d-flex align-items-center"
        >
          <el-form-item>
            <el-button
              :disabled="disablePrint"
              @click="onPrint"
              v-if="showPrint"
              :title="printButtonTitle"
              type="button"
              class="print-btn"
            >
              <span class="el-icon-printer"></span>Print Barcodes
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="inner-content">
        <div class id="barcodesBody">
          <div
            v-for="(caseInfo, index) in generatedCaseIds"
            :key="index"
            style="margin-top: 20px"
            class="each-barcode"
          >
            <div class="barcode">
              <div class="show-barcode">
                <el-row>
                  <el-col :span="24">
                    <div class="barcode-body" id="barcodeBody">
                      <div class="bar-code-table">
                        <div
                          class="bar-code-table-inner"
                          style="padding: 5px 10px"
                        >
                          <table
                            style="width: 100%; padding: 1em; max-width: 550px"
                          >
                            <tbody>
                              <tr style="vertical-align: middle">
                                <th
                                  class="patient-name-block"
                                  style="
                                    text-align: left;
                                    text-transform: uppercase;
                                  "
                                >
                                  <div
                                    class="patient-name-single-line"
                                    v-if="caseInfo.patient_info"
                                    style="display: flex; align-items: center; gap: 10px;"
                                  >
                                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1;">
                                      {{ caseInfo.patient_info.first_name }}
                                      {{
                                        caseInfo.patient_info.middle_name
                                          ? caseInfo.patient_info.middle_name
                                          : ""
                                      }}
                                      {{ caseInfo.patient_info.last_name }}
                                    </span>
                                    <span style="white-space: nowrap; font-size: 10px; flex-shrink: 0;">
                                      DOB:
                                      {{
                                        dateWithMomentUTC(
                                          caseInfo.patient_info.date_of_birth
                                        )
                                      }}
                                    </span>
                                  </div>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <div class="content" style="margin-top: 10px;">
                            <el-row>
                              <el-col :span="24">
                                <div class="image">
                                  <BarcodeGenerator
                                    :value="getBarcodeValue(caseInfo, index)"
                                    font="arial"
                                    font-size="18"
                                    height="76"
                                    :width="1.4"
                                    display-value="false"
                                    :margin="0"
                                    v-if="caseInfo.accession_id"
                                  ></BarcodeGenerator>
                                </div>
                                <div
                                  class="assession-id-with-mcode"
                                  style="
                                    text-align: center;
                                    font-size: 11.953325px !important;
                                    font-weight: 600;
                                    letter-spacing: 0.15pt;
                                    line-height: 1;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    gap: 8px;
                                  "
                                >
                                  <span>{{ getBarcodeValue(caseInfo, index) }}</span>
                                  <span v-if="getDisplayMCode(caseInfo)" style="font-size: 10px; font-weight: 500;">
                                    {{ getDisplayMCode(caseInfo) }}
                                  </span>
                                  <span
                                    v-if="isCA600Barcode(caseInfo) && caseInfo.test_names"
                                    style="font-size: 10px; font-weight: 500;"
                                  >
                                    {{ caseInfo.test_names }}
                                  </span>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="no-barcode"
      v-if="
        !generatedCaseIds.length ||
        (!loading &&
          (!getMultipleTestBarcodeSources ||
            !getMultipleTestBarcodeSources.length))
      "
    >
      <p>Unable to generate barcodes.</p>
    </div>
  </Section>
</template>

<script>
import { mapGetters } from "vuex";
import caseDataHelper from "@/mixins/caseDataHelper";

import BarcodeGenerator from "./BarcodeGenerator.vue";
import moment from "moment-timezone";
import {
  getSampleTypeSuffix,
  shouldApplySuffix,
  isCA600MCode,
  extractCodePrefix,
  M_CODE_DISPLAY_RULES,
  getBarcodeAccession,
} from "@/config/constants/barcodeConstants";
export default {
  mixins: [caseDataHelper],
  computed: {
    ...mapGetters("cases", [
      "getMultipleTestBarcodeSources",
      "getMultipleTestBarcodeStatus",
      "getCaseInformation",
    ]),
    ...mapGetters("profile", ["getProfileData"]),
    caseInformationMap() {
      if (
        !this.getMultipleTestBarcodeSources ||
        !this.getMultipleTestBarcodeSources.length
      ) {
        return {};
      }

      const data = {};

      this.getMultipleTestBarcodeSources.forEach((el) => {
        data[el.case_id] = {
          ...el.case_information,
          test_config: el.test_config || [],
        };
      });
      return data;
    },
    barCodeUrlsMap() {
      if (
        !this.getMultipleTestBarcodeSources ||
        !this.getMultipleTestBarcodeSources.length
      ) {
        return {};
      }

      const data = {};

      this.getMultipleTestBarcodeSources.forEach((el) => {
        data[el.case_id] = el.barcode_source;
      });

      return data;
    },
    printButtonTitle() {
      return this.disablePrint ? "Wait until images are ready" : "";
    },
    trimmedPatientName() {
      return (caseId) => {
        let caseData = this.caseInformationMap[caseId];
        if (caseData) {
          if (caseData.patient_info.middle_name) {
            let name =
              caseData.patient_info.first_name +
              " " +
              caseData.patient_info.middle_name +
              " ";
            caseData.patient_info.last_name;

            return name.slice(0, 13);
          } else {
            let name =
              caseData.patient_info.first_name +
              " " +
              caseData.patient_info.last_name;

            return name.slice(0, 13);
          }
        }
        return "";
      };
    },
    trimmedDoctorName() {
      return (caseId) => {
        let caseData = this.caseInformationMap[caseId];
        if (caseData) {
          let name = caseData.ordering_physician.name;
          return name.slice(0, 13);
        }
        return "";
      };
    },
    trimmedCaseDetails() {
      return (caseId) => {
        let caseName = this.caseTypesText(
          this.caseInformationMap[caseId].case_types
        );
        return caseName ? caseName.slice(0, 35) : "";
      };
    },
  },
  components: {
    BarcodeGenerator,
  },
  async mounted() {
    await this.generateBarcodes();
  },
  data() {
    return {
      showBarcodes: false,
      showPrint: false,
      disablePrint: false,
      loading: false,
      caseIds: [],
      generatedCaseIds: [],
      barcodeCopies: 1,
    };
  },

  methods: {
    async generateBarcodes() {
      this.loading = true;
      let params = {};
      try {
        if (this.$route.query.case_ids) {
          const caseIds = this.$route.query.case_ids;
          if (caseIds) {
            params.case_ids = [];
            if (typeof caseIds == "string") {
              params.case_ids.push(caseIds);
            } else {
              params.case_ids = caseIds;
            }
          } else {
            this.loading = false;
            return;
          }
        } else if (this.$route.query.from_date && this.$route.query.to_date) {
          params.from_received_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.$route.query.from_date))
            .startOf("day")
            .utc()
            .format();

          params.to_received_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.$route.query.to_date))
            .endOf("day")
            .utc()
            .format();
        }
        params.key = "BAR_CODES";

        await this.$store.dispatch(
          "cases/generateMultipleTestBarcodes",
          params
        );

        if (this.getMultipleTestBarcodeStatus) {
          this.getMultipleTestBarcodeSources.forEach((el) => {
            for (let i = 0; i < (el.test_config.length || 1); i++) {
              this.generatedCaseIds.push(el.case_id);
            }
          });
          this.generateCaseIds();
          this.showBarcodes = true;
          this.showPrint = true;
          this.disablePrint = true;

          setTimeout(() => {
            this.disablePrint = false;
          }, 2000);
        } else {
          this.$notify({
            type: "Error",
            title: "Failed",
            message: "Failed to generate multiple barcodes",
          });
        }
        this.caseInfo = JSON.parse(JSON.stringify(this.getCaseInformation));
      } catch (err) {
        console.log(err);
      }

      this.loading = false;
    },

    async onPrint() {
      // await this.$htmlToPaper("barcodesBody");
      window.print();
    },
    generateBarcodeCopies() {
      this.showBarcodes = false;
      if (this.getMultipleTestBarcodeStatus) {
        this.generatedCaseIds = [];
        for (let i = 1; i <= this.barcodeCopies; i++) {
          this.getMultipleTestBarcodeSources.forEach((el) => {
            // this.generatedCaseIds.push(el.case_id);
            for (let j = 0; j < (el.test_config.length || 1); j++) {
              this.generatedCaseIds.push(el.case_id);
            }
          });
        }
      } else {
        this.$notify({
          type: "Error",
          title: "Failed",
          message: "Failed to generate multiple barcodes",
        });
      }
      this.showBarcodes = true;
    },
    generateCaseIds() {
      if (
        !this.getMultipleTestBarcodeSources ||
        !this.getMultipleTestBarcodeSources.length
      ) {
        this.generatedCaseIds = [];
        return;
      }

      const generatedCaseIds = [];

      this.getMultipleTestBarcodeSources.forEach((el) => {
        if (el.test_config && el.test_config.length) {
          el.test_config.forEach((config) => {
            const barcodeData = {
              accession_id: el.case_information.accession_id,
              case_types: el.case_information.case_types.join(", "), // Convert array to comma-separated string
              collection_date: el.case_information.collection_date,
              received_date: el.case_information.received_date,
              patient_info: el.case_information.patient_info,
              test_names: config.test_names.join(", "), // Join test names into a comma-separated string
              m_code: config.m_code.join(", "),
              sample_type:config.sample_type
            };
            generatedCaseIds.push(barcodeData);
          });
        } else {
          const barcodeData = {
            accession_id: el.case_information.accession_id,
            case_types: el.case_information.case_types.join(", "), // Convert array to comma-separated string
            collection_date: el.case_information.collection_date,
            received_date: el.case_information.received_date,
            patient_info: el.case_information.patient_info,
            test_names: "", // No test names if test_config is empty
            m_code :[],
            sample_type:""
          };
          generatedCaseIds.push(barcodeData);
        }
      });

      this.generatedCaseIds = generatedCaseIds;
    },
    getBarcodeValue(caseInfo, index) {
      const accessionValue = getBarcodeAccession(caseInfo.accession_id);

      // Add suffix if required
      const suffix = shouldApplySuffix(caseInfo.m_code)
        ? getSampleTypeSuffix(caseInfo.sample_type)
        : null;
      
      return suffix ? `${accessionValue}-${suffix}` : accessionValue;
    },
    
    isCA600Barcode(caseInfo) {
      // CA600 / CA-600 barcodes show the test names in tiny text beside the
      // m-code display.
      return isCA600MCode(caseInfo.m_code);
    },
    getDisplayMCode(caseInfo) {
      if (!caseInfo.m_code || caseInfo.m_code.length === 0) {
        return '';
      }

      const mCodeArray = Array.isArray(caseInfo.m_code) 
        ? caseInfo.m_code 
        : caseInfo.m_code.split(',').map(code => code.trim());

      // Check if it contains urine or plasma - display "c-series"
      const hasUrineOrPlasma = mCodeArray.some(code => 
        M_CODE_DISPLAY_RULES.URINE_PLASMA_CODES.includes(code.toLowerCase())
      );
      
      if (hasUrineOrPlasma) {
        return M_CODE_DISPLAY_RULES.URINE_PLASMA_DISPLAY;
      }

      // Check if it contains i-series AND c-series - display as is
      const hasISeries = mCodeArray.some(code => 
        code.toLowerCase().includes(M_CODE_DISPLAY_RULES.I_SERIES)
      );
      const hasCSeries = mCodeArray.some(code => 
        code.toLowerCase().includes(M_CODE_DISPLAY_RULES.C_SERIES)
      );
      
      if (hasISeries && hasCSeries) {
        return M_CODE_DISPLAY_RULES.COMBINED_DISPLAY;
      }

      // For rest scenarios - display only first characters
      const displayCodes = mCodeArray.map(code => extractCodePrefix(code));

      return displayCodes.join(', ');
    },
  },

  unmounted() {
    this.$store.dispatch("cases/resetGenerateMultipleBarcodes");
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap");
#multiple-barcode-view {
  padding: 2em 0;
  font-family: "Open Sans", sans-serif;
  @page {
    size: A4;
    margin: 0 auto;
    width: 288px;
    // margin: 0 auto;
    height: 192px;
  }
  .number-counter {
    .el-input__inner {
      padding-right: 0 !important;
      font-weight: 500;
      color: #000;
      font-size: 15px;
    }
  }
  .each-barcode {
    margin-top: 0 !important;
    page-break-inside: avoid;
    page-break-after: avoid;
  }
  .barcode-form-inline {
    .el-form-item {
      margin-bottom: 0;
    }
    margin-bottom: 45px;
  }
  #barcodeBody {
    .bar-code-table {
      width: 288px;
      margin: 4.85em auto;
      height: 192px;
      overflow: hidden;
      padding: 0;
      transform: rotate(90deg);
      table {
        padding: 10px 5px 0 10px !important;
      }
      th {
        font-size: 14px;
      }
      .designation {
        margin-top: 0;
      }
      .dates {
        p {
          line-height: 20px;
          font-size: 13px;
        }
      }
      .image {
        img {
          max-width: 200px;
          margin: 0 auto;
        }
        &.diasorin {
          img {
            max-width: 180px;
          }
        }
      }
    }
  }
  .inner-navbar {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    margin-right: 10px;
    .print-btn {
      background: #6f52ed;
      padding: 9px 15px;
      color: #fff;
      font-size: 1em;
      span {
        padding-right: 5px;
      }
    }
  }
  .inner-content {
    .bar-code-table {
      background: #fff;
      padding: 10px;
      .image {
        display: table;
        margin: 0 auto;
        max-width: 100% !important;
      }
      .case-types {
        text-align: center;
        b {
          font-size: 15px;
        }
      }
      table {
        margin: 0 auto;
      }
    }
  }
  .each-barcode {
    display: table;
    margin: 20px auto;
    margin-bottom: 20px;
  }
  @media print {
    .each-barcode {
      margin: 0 !important;
      display: block !important;
    }
    .inner-navbar {
      display: none !important;
      margin-top: 0 !important;
      margin-right: 0 !important;
    }
  }

  // @media print {
  #barcodeBody .bar-code-table {
    page-break-before: always;
    margin-bottom: 45px !important;
    margin-left: -48px !important;
    margin-right: 0 !important;
    background: #fff !important;
    margin-top: 48px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .designation {
    margin-top: 0 !important;
    font-size: 8px !important;
  }
  #barcodeBody .bar-code-table .image img {
    // max-width: 100%;
    // height: 50px;
    margin-bottom: -5px;
  }
  #barcodeBody .bar-code-table #assession-id {
    text-align: center;
    font-size: 7pt !important;
    font-weight: 500;
    letter-spacing: 0.15pt;
    line-height: 1;
    padding-bottom: 0;
    margin-bottom: -20px;
  }
  #barcodeBody .bar-code-table .assession-id-with-mcode {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px;
    text-align: center;
    font-size: 11.953325px !important;
    font-weight: 600;
    letter-spacing: 0.15pt;
    line-height: 1;
  }
  #barcodeBody .bar-code-table .assession-id-with-mcode span {
    display: inline-block;
  }
  #barcodeBody .bar-code-table th {
    font-size: 7px !important;
    font-weight: normal;
    letter-spacing: 0.1px;
  }
  #barcodeBody .bar-code-table .patient-name-block {
    padding-top: 10px;
  }
  #barcodeBody .bar-code-table .patient-name-single-line {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  #barcodeBody .bar-code-table .patient-name-single-line span:first-child {
    font-size: 11px;
    font-weight: 500;
    line-height: 11px;
    letter-spacing: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  #barcodeBody .bar-code-table .patient-name-single-line span:last-child {
    font-size: 10px;
    font-weight: 500;
    line-height: 11px;
    letter-spacing: 0;
    flex-shrink: 0;
    white-space: nowrap;
  }
  #barcodeBody .bar-code-table .date-column {
    width: 95px;
  }
  #barcodeBody .bar-code-table .patient-name {
    font-size: 11px;
    font-weight: 500;
    line-height: 11px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    letter-spacing: 0;
  }
  #barcodeBody .bar-code-table .dates {
    font-size: 8pt;
    font-weight: 700;
    padding-right: 15px;
  }
  #barcodeBody .bar-code-table .dates p {
    line-height: 12px;
    font-size: 10px !important;
    width: 95px;
    font-weight: 800;
    letter-spacing: 0.2px;
  }
  .inner-content .bar-code-table .case-types b {
    font-size: 11px !important;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 1;
    padding-top: 0;
    margin: -10px 0 0 !important;
  }
  .bar-code-table-inner {
    width: 100%;
    padding: 10px 10px 6px 30px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .patient-name-block {
    padding-left: 15px;
  }
  padding-top: 0 !important;

  #multiple-barcode-view {
    padding-top: 0;
  }
}
.no-barcode {
  text-align: center;
  font-size: 1.1em;
}

.barCodeTestNames {
  font-size: 11px;
  font-weight: 500;
  width: 250px;
  margin: auto;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bar-code-table-inner {
  padding-bottom: 10px !important;
}
#multiple-barcode-view .inner-content .bar-code-table .case-types {
  line-height: 10px;
}
</style>
